export default "__VITE_ASSET__BrDMglch__"